const AffiliationsStepEnum = {
    AFFILIATION_LIST: 'affiliationsList',
    CONFIRM_COUNTRY: 'confirmCountry',
    CONFIRM_PRICE_CHANGE: 'confirmPriceChange',
    SELECT_AFFILIATION_BY_COUNTRY: 'selectAffiliationByCountry',
    SELECT_PRIMARY_AFFILIATION: 'selectPrimaryAffiliation',
} as const;

export default AffiliationsStepEnum;
